module.exports = __webpack_public_path__ + "media/images/journey-night03-b6c21cebb8d9dc3240cb83bd5028e94e.jpg";